import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { EventOrganizersRequestState, EventParticipantsRequestState, GetEventOrganizers, GetEventParticipants } from "../../../store/ScheduleSync/ScheduleSyncEventAction";
import StatusCode from "../../../util/StatusCode";
import ActiveToggle from "../../misc/ActiveToggle";
import TableHorizontalPagedToggle from "../../misc/TableHorizontalPagedToggle";
import * as Helper from '../../../util/Helper';
import { PageResult, CoreDisplayableRef } from "../../../models/CoreModels";
import { RequestState } from "../../../models/RequestState";
import { useTranslation } from 'react-i18next';
import { RootState } from "../../../store/store";



const ScheduleSyncEventMembers = () => {
    const { t } = useTranslation(['common', 'scheduleSync']);
    const { eventId } = useParams();
    const dispatch = useDispatch();
    const organizers = useSelector<RootState, EventOrganizersRequestState>(state => state.schedulesync_events.eventOrganizers);
    const participants = useSelector<RootState, EventParticipantsRequestState>(state => state.schedulesync_events.eventParticipants);

    const [show, setShow] = useState({ organizers: true, participants: true });

    useEffect(() => {
        if (eventId) {
            GetEventOrganizers(eventId, { ...organizers?.filter })(dispatch);
            GetEventParticipants(eventId, { ...participants?.filter })(dispatch);
        }
    }, [dispatch, eventId]);
    
    const updateParticipantsPage = (value: number) => {
        if (eventId) {
            GetEventParticipants(eventId, { ...participants.filter, page: value })(dispatch);
        }
    }
    const updateOrganizersPage = (value: number) => {
        if (eventId) {
            GetEventOrganizers(eventId, { ...organizers.filter, page: value })(dispatch);
        }
    }
    const updateOnlyActive = (value: boolean) => {
        if (eventId) {
            GetEventParticipants(eventId, { ...participants.filter, onlyActive: value, page: 1 })(dispatch);
            GetEventOrganizers(eventId, { ...organizers.filter, onlyActive: value, page: 1 })(dispatch);
        }
    }

    const mapUsers = (users: RequestState<PageResult<CoreDisplayableRef>>) => {
        if (users.code !== StatusCode.COMPLETE) {
            return [];
        }
        return users.data?.values.map(x => ({
            id: x.id,
            data: [
                { value: <Link to={`/schedulesync/user/${x.id}/information`}>{x.title}</Link> },
                { value: Helper.active(x.active) },
            ]
        }));
    }

    const renderOrganizers = () => {
        const count = Helper.getTotalCountText(organizers);
        return (
            <TableHorizontalPagedToggle
                header={[{ value: `${t('userSchedule.organizer', { ns: 'scheduleSync' })} ${count}` }, { value: t('genericTableHeaders.active', {ns:'common'}) }]}
                mobileHeader={[t('genericTableHeaders.name', { ns: 'common' }), t('genericTableHeaders.active', { ns: 'common' })]}
                info={mapUsers(organizers)}
                show={show.organizers}
                toggle={() => setShow({ ...show, organizers: !show.organizers })}
                displayName={`${t('userSchedule.organizer', { ns: 'scheduleSync' })} ${count}`}
                noResultMsg={t('noResult.eventOrganizers', { ns: 'scheduleSync' })}
                onChangePage={(p) => updateOrganizersPage(p)}
                requestState={organizers}
            />
        )
    }

    const renderParticipants = () => {
        const count = Helper.getTotalCountText(participants);
        return (
            <TableHorizontalPagedToggle
                header={[{ value: `${t('userSchedule.participant', {ns: 'scheduleSync'})} ${count}` }, { value: t('genericTableHeaders.active', { ns: 'common' }) }]}
                mobileHeader={[t('genericTableHeaders.name', { ns: 'common' }), t('genericTableHeaders.active', { ns: 'common' })]}
                info={mapUsers(participants)}
                show={show.participants}
                toggle={() => setShow({ ...show, participants: !show.participants })}
                displayName={`${t('userSchedule.participant', { ns: 'scheduleSync' })} ${count}`}
                noResultMsg={t('noResult.eventParticipants', { ns: 'scheduleSync' })}
                onChangePage={(p) => updateParticipantsPage(p)}
                requestState={participants}
            />
        )
    }

    return (<>
        <div className="header_member_table large">{t('event.members.title', {ns: 'scheduleSync'})}
            <span className="right">
                <ActiveToggle
                    onlyActive={organizers?.filter?.onlyActive ?? true}
                    update={(active) => updateOnlyActive(active)}
                    disabled={organizers.code === StatusCode.PENDING || participants.code === StatusCode.PENDING}
                />
            </span></div>
        {renderOrganizers()}
        {renderParticipants()}
    </>);
}

export default ScheduleSyncEventMembers;
